import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=78b3310f&"
import script from "./Chat.vue?vue&type=script&lang=js&"
export * from "./Chat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78b3310f')) {
      api.createRecord('78b3310f', component.options)
    } else {
      api.reload('78b3310f', component.options)
    }
    module.hot.accept("./Chat.vue?vue&type=template&id=78b3310f&", function () {
      api.rerender('78b3310f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/SettingRenew/Contents/Chat.vue"
export default component.exports